import { Box, Typography } from '@mui/material';

/**
 * AnooreHR brand mark — JSX-rendered to match the marketing site Navbar.
 *
 * Used on login, signup, forgot-password and reset-password pages. Replaces
 * the legacy talentsapartment / ETG logo.jpg. Themes via MUI palette so the
 * `primary.main` automatically follows the active palette (kova by default).
 */
export interface AnoorehrLogoProps {
  /** Wordmark on the right of the rounded mark. Defaults to "AnooreHR". Pass `false` to render mark-only. */
  showWordmark?: boolean;
  /** Pixel size of the rounded square mark. Wordmark scales proportionally. */
  size?: number;
  /** Color of the wordmark text. Defaults to `text.primary`. */
  textColor?: string;
}

export default function AnoorehrLogo({
  showWordmark = true,
  size = 40,
  textColor,
}: AnoorehrLogoProps) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.25 }}>
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: `${Math.round(size * 0.28)}px`,
          bgcolor: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Typography
          component="span"
          sx={{
            color: 'common.white',
            fontWeight: 800,
            fontSize: Math.round(size * 0.5),
            lineHeight: 1,
            fontFamily:
              '"Satoshi", "Outfit", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          }}
        >
          A
        </Typography>
      </Box>
      {showWordmark && (
        <Typography
          component="span"
          sx={{
            fontWeight: 800,
            fontSize: Math.round(size * 0.55),
            letterSpacing: '-0.02em',
            color: textColor ?? 'text.primary',
            fontFamily:
              '"Satoshi", "Outfit", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            lineHeight: 1,
          }}
        >
          AnooreHR
        </Typography>
      )}
    </Box>
  );
}
